import React from 'react'
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

const dot = (color) => ({
    height: "12px",
    width: "12px",
    backgroundColor: color,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "6px",
});

const ActiveTestRun = ({
    total = 0,
    passed = 0,
    untested = 0,
    failed = 0,
    retest = 0,
    skipped = 0,
    blocked = 0,
}) => {
    const data = {
        labels: ["Passed", "Untested", "Failed", "Retest", "Skipped", "Blocked"],
        datasets: [
            {
                data: [passed, untested, failed, retest, skipped, blocked],
                backgroundColor: [
                    "#2ecc71",
                    "#e5e7eb",
                    "#e74c3c",
                    "#f1c40f",
                    "#95a5a6",
                    "#7f7fff",
                ],
                borderWidth: 0,
                cutout: "70%",
            },
        ],
    };

    const options = {
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
        },
        maintainAspectRatio: false,
    };

    return (
        <div style={{ width: "100%", maxWidth: "650px", margin: "auto", border: '2px solid #e5e7eb', borderRadius: '8px', padding: '16px' }}>

            <h6
                style={{
                    textAlign: "start",
                    marginBottom: "10px",
                    color: "#111827",
                    fontWeight: "500",
                }}
            >
                Active Test Run
            </h6>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "40px",
                    justifyContent: "center",
                }}
            >
                <div style={{ position: "relative", width: "250px", height: "250px" }}>
                    <Doughnut data={data} options={options} />

                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            fontSize: "26px",
                            fontWeight: "bold",
                            color: "#374151",
                        }}
                    >
                        {total}
                        <br />
                        <span
                            style={{
                                fontSize: "14px",
                                fontWeight: "normal",
                                color: "#6b7280",
                            }}
                        >
                            Total Test Cases
                        </span>
                    </div>
                </div>

                <div>
                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            fontSize: "14px",
                        }}
                    >
                        <li>
                            <span style={dot("#2ecc71")}></span> Passed {passed} (
                            {total > 0 ? ((passed / total) * 100).toFixed(1) : 0}%)
                        </li>
                        <li>
                            <span style={dot("#e5e7eb")}></span> Untested {untested} (
                            {total > 0 ? ((untested / total) * 100).toFixed(1) : 0}%)
                        </li>
                        <li>
                            <span style={dot("#e74c3c")}></span> Failed {failed} (
                            {total > 0 ? ((failed / total) * 100).toFixed(1) : 0}%)
                        </li>
                        <li>
                            <span style={dot("#f1c40f")}></span> Retest {retest} (
                            {total > 0 ? ((retest / total) * 100).toFixed(1) : 0}%)
                        </li>
                        <li>
                            <span style={dot("#95a5a6")}></span> Skipped {skipped} (
                            {total > 0 ? ((skipped / total) * 100).toFixed(1) : 0}%)
                        </li>
                        <li>
                            <span style={dot("#7f7fff")}></span> Blocked {blocked} (
                            {total > 0 ? ((blocked / total) * 100).toFixed(1) : 0}%)
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ActiveTestRun
